<div class="callout color-900"
     [class]="callout.style ?? 'primary'"
     data-test="callout">
  <div class="container bg-transparent flex-row align-items-center py-2">
    <span *ngIf="callout?.asset" class="me-2 svg-vertical-align-text-bottom">
      <flo-svg-icon [icon]="callout?.asset.style" width="1.25em"></flo-svg-icon>
    </span>
    <span class="caption" data-test="callout-title">{{ callout.title }}</span>
  </div>
</div>
